import { render } from "./PaginationButtons.vue?vue&type=template&id=7b0174d0"
import script from "./PaginationButtons.vue?vue&type=script&lang=js"
export * from "./PaginationButtons.vue?vue&type=script&lang=js"

import "./PaginationButtons.vue?vue&type=style&index=0&id=7b0174d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__